import * as z from 'zod';

export const RoleRuntype = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    is_system_role: z.boolean(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    zed_token: z.string().nullable(),
});

export type Role = z.infer<typeof RoleRuntype>;

// Module enum to match the database 'module_enum' type
export const ModuleEnum = z.enum([
    'dashboard',
    'design',
    'sourcing',
    'manufacturing',
    'calculation',
    'quotation',
    'customer_portal',
    'supplier_portal',
    'organization_settings',
]);

export type Module = z.infer<typeof ModuleEnum>;
const supportedModules = [
    'calculation',
    'dashboard',
    'design',
    'manufacturing',
    'sourcing',
    'quotation',
] as const satisfies ReadonlyArray<Module>; // <-- compile-time check here

// Then create the Zod enum from the subset
export const SupportedModulesEnum = z.enum(supportedModules);

// RoleAccessLevel enum to match the database 'role_access_level_enum' type
export const RoleAccessLevelEnum = z.enum(['viewer', 'editor', 'manager']);

export type RoleAccessLevel = z.infer<typeof RoleAccessLevelEnum>;

// RoleAccess runtype to match the 'role_access' table
export const RoleAccessRuntype = z.object({
    role_id: z.string(),
    module: ModuleEnum,
    access_level: RoleAccessLevelEnum,
});

export type RoleAccess = z.infer<typeof RoleAccessRuntype>;

// Create role request runtype
export const CreateRoleRuntype = z.object({
    name: z.string(),
    description: z.string().nullable(),
});

export type CreateRole = z.infer<typeof CreateRoleRuntype>;

// Update role request runtype
export const UpdateRoleRuntype = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
});

export type UpdateRole = z.infer<typeof UpdateRoleRuntype>;

export const CreateRoleAccessRuntype = RoleAccessRuntype;

export const DeleteRoleAccessRuntype = z.object({
    role_id: z.string(),
    module: ModuleEnum,
    access_level: RoleAccessLevelEnum,
});

const PermissionKindEnum = z.enum(['view', 'edit', 'manage']);
export type PermissionKind = z.infer<typeof PermissionKindEnum>;

export const ModulePermissionRuntype = z.object({
    module: ModuleEnum,
    permission: PermissionKindEnum,
});
export type ModulePermission = z.infer<typeof ModulePermissionRuntype>;

export const UserRoleMembershipInsertRuntype = z.object({
    user_id: z.string(),
    role_id: z.string(),
});
export type UserRoleMembershipInsert = z.infer<typeof UserRoleMembershipInsertRuntype>;

export const UserRoleMembershipRuntype = UserRoleMembershipInsertRuntype.extend({
    updated_at: z.string().datetime(),
});
export type UserRoleMembership = z.infer<typeof UserRoleMembershipRuntype>;
